module.exports = __webpack_public_path__ + "img/bibliotheque.6047068e.png";